module.exports = __webpack_public_path__ + "img/4.d30c6452.jpg";